import { Hub, HubResponse } from '@goldcast/api/backend';

import { EventHubPages } from './types';

export function transformServerEventHubPages(eventHubPages: Array<HubResponse | Hub>): EventHubPages {
  const transformedEvents = {};

  eventHubPages.forEach(eventHubPage => {
    transformedEvents[eventHubPage.id] = eventHubPage;
  });

  return transformedEvents;
}
